import { useEffect, useState } from "react";
import { ToolboxIcon } from "@phosphor-icons/react";

import Layout from "../../components/Layout";
import EntityHeader from "../../components/crm/EntityHeader";
import { ErrorBanner } from "../../components/crm/Form";
import WorkOrderCard from "../../components/ops/WorkOrderCard";
import { useAuth } from "../../contexts/AuthContext";
import api, { formatApiError } from "../../lib/api";

export default function MyWorkOrders() {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    setErr("");
    try {
      const { data } = await api.get("/work-orders/me");
      setList(data);
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
  }, []);

  const upcoming = list.filter((w) => !["completed", "canceled"].includes(w.status));
  const done = list.filter((w) => ["completed", "canceled"].includes(w.status));

  return (
    <Layout title="My Work" subtitle="Today on the road">
      <EntityHeader
        overline="my work"
        title={`Hello, ${user?.name?.split(" ")[0] || ""}`}
        subtitle="Work orders assigned to you. Tap a card to start."
      />

      <ErrorBanner message={err} />

      <section data-testid="my-work-active" className="mb-6">
        <div className="font-data text-[10px] uppercase tracking-[0.22em] text-slate-500 mb-2">
          // active &middot; {upcoming.length}
        </div>
        {!loading && upcoming.length === 0 ? (
          <div
            data-testid="my-work-empty"
            className="bg-white border-2 border-dashed border-slate-200 rounded-sm p-8 text-center"
          >
            <ToolboxIcon
              size={28}
              weight="duotone"
              className="mx-auto text-slate-400"
            />
            <div className="font-heading text-sm font-semibold text-slate-900 mt-3">
              No active assignments
            </div>
            <p className="text-xs text-slate-500 mt-1 max-w-sm mx-auto">
              When dispatch assigns you a job, it'll appear here.
            </p>
          </div>
        ) : (
          <div className="space-y-2">
            {upcoming.map((w) => (
              <WorkOrderCard key={w.id} wo={w} />
            ))}
          </div>
        )}
      </section>

      {done.length > 0 && (
        <section data-testid="my-work-done">
          <div className="font-data text-[10px] uppercase tracking-[0.22em] text-slate-500 mb-2">
            // recent &middot; {done.length}
          </div>
          <div className="space-y-2">
            {done.map((w) => (
              <WorkOrderCard key={w.id} wo={w} compact />
            ))}
          </div>
        </section>
      )}
    </Layout>
  );
}
